import React from 'react';
import { PaymentElement } from '@stripe/react-stripe-js';
import StripePaymentButton from '../stripe-payment-button/StripePaymentButton.js';
var StripePaymentElement = function StripePaymentElement(_ref) {
  var beforeButtonContent = _ref.beforeButtonContent,
    billing_details = _ref.billingDetails,
    classNames = _ref.classNames,
    _ref$onReadyToRenderH = _ref.onReadyToRenderHandler,
    onReadyToRenderHandler = _ref$onReadyToRenderH === void 0 ? function () {} : _ref$onReadyToRenderH,
    _ref$onSubmitHandler = _ref.onSubmitHandler,
    onSubmitHandler = _ref$onSubmitHandler === void 0 ? function () {} : _ref$onSubmitHandler,
    isDisabled = _ref.isDisabled,
    renderPaymentButton = _ref.renderPaymentButton;
  var onConfirmHandler = function onConfirmHandler(event) {
    event === null || event === void 0 || event.preventDefault();
    onSubmitHandler({
      billingDetails: billing_details
    });
  };
  var onReadyHandler = function onReadyHandler() {
    onReadyToRenderHandler(true);
  };
  return React.createElement("form", {
    className: classNames === null || classNames === void 0 ? void 0 : classNames.form,
    onSubmit: onConfirmHandler
  }, React.createElement("div", {
    className: classNames === null || classNames === void 0 ? void 0 : classNames.paymentElement
  }, React.createElement(PaymentElement, {
    options: {
      layout: {
        type: 'tabs',
        defaultCollapsed: false
      },
      fields: {
        billingDetails: {
          name: 'auto',
          address: 'never'
        }
      },
      wallets: {
        applePay: 'never',
        googlePay: 'never'
      }
    },
    onReady: onReadyHandler
  })), React.createElement("div", {
    className: classNames === null || classNames === void 0 ? void 0 : classNames.beforeButtonContent
  }, beforeButtonContent), React.createElement("div", {
    className: classNames === null || classNames === void 0 ? void 0 : classNames.paymentButton
  }, React.createElement(StripePaymentButton, {
    isDisabled: isDisabled,
    renderPaymentButton: renderPaymentButton
  })));
};
export { StripePaymentElement as default };